<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/Zaufanie'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-20 flex flex-col gap-15"
    >
      <div class="flex flex-col gap-7.5 items-center">
        <span class="text-H2 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>
        <span class="text-H4 text-Tekst text-center">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
      </div>
      <CmsCustomComponentList
        v-slot="{ component_values: componentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
        :open-options="true"
        component-name="images_list"
        class="min-w-5 min-h-5 flex flex-row gap-10 flex-wrap items-center justify-center"
      >
        <div
          v-for="(item, index) in componentListValues"
          :key="JSON.stringify(item)"
          class="rounded-3xl bg-background-1 py-10 px-8 flex flex-col gap-5 items-center"
        >
          <span class="text-H4 text-Tekst text-center">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'text']"
            />
          </span>
          <CmsLink
            v-slot="{ link }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'link']"
          >
            <AppButton
              :href="link?.href"
              :target="link?.target"
              download
              button-theme="Transparent-Teksty"
              arrow
            >
              <span class="link-text">{{ link?.link_text ?? 'lorem ipsum' }}</span>
            </AppButton>
          </CmsLink>
        </div>
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
